// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { TranslateService } from '@ngx-translate/core';
import * as Domain from '@core/Domain';

export class DomainIit {

  static Init(translateService: TranslateService) {
const domain_LocalResourcesDefinition = new Domain.Domain_LocalResourcesDefinition(translateService);
const globalResourcesDefinition = new Domain.GlobalResourcesDefinition(translateService);
const organisation = new Domain.Organisation(translateService);
const department = new Domain.Department(translateService);
const bankAccount = new Domain.BankAccount(translateService);
const bank = new Domain.Bank(translateService);
const facility = new Domain.Facility(translateService);
const organizationalAffiliation = new Domain.OrganizationalAffiliation(translateService);
const auditTrailHelper = new Domain.AuditTrailHelper(translateService);
const auditTrailConfigurationDTO = new Domain.AuditTrailConfigurationDTO(translateService);
const userAccount = new Domain.UserAccount(translateService);
const appToken = new Domain.AppToken(translateService);
const savedView = new Domain.SavedView(translateService);
const project = new Domain.Project(translateService);
const projectTask = new Domain.ProjectTask(translateService);
const projConfiguration = new Domain.ProjConfiguration(translateService);
const reportingPeriod = new Domain.ReportingPeriod(translateService);
const projectTeamMember = new Domain.ProjectTeamMember(translateService);
const projectParticipant = new Domain.ProjectParticipant(translateService);
const projectReport = new Domain.ProjectReport(translateService);
const projectMemberYear = new Domain.ProjectMemberYear(translateService);
const autoPlanConfiguration = new Domain.AutoPlanConfiguration(translateService);
const importProcessResult = new Domain.ImportProcessResult(translateService);
const importProcessMessage = new Domain.ImportProcessMessage(translateService);
const workPackage = new Domain.WorkPackage(translateService);
const participantWorkAssignment = new Domain.ParticipantWorkAssignment(translateService);
const projectContract = new Domain.ProjectContract(translateService);
const document = new Domain.Document(translateService);
const deliverable = new Domain.Deliverable(translateService);
const disseminationLevel = new Domain.DisseminationLevel(translateService);
const deliverableType = new Domain.DeliverableType(translateService);
const milestone = new Domain.Milestone(translateService);
const projectReview = new Domain.ProjectReview(translateService);
const workplanItem = new Domain.WorkplanItem(translateService);
const competency = new Domain.Competency(translateService);
const projectPayment = new Domain.ProjectPayment(translateService);
const projectPaymentTerm = new Domain.ProjectPaymentTerm(translateService);
const country = new Domain.Country(translateService);
const countryHoliday = new Domain.CountryHoliday(translateService);
const countryDataItem = new Domain.CountryDataItem(translateService);
const holidayResult = new Domain.HolidayResult(translateService);
const currency = new Domain.Currency(translateService);
const yearDataItem = new Domain.YearDataItem(translateService);
const city = new Domain.City(translateService);
const costStatement = new Domain.CostStatement(translateService);
const personnelCostsPerCategoryDetail = new Domain.PersonnelCostsPerCategoryDetail(translateService);
const subcontractingCostDetail = new Domain.SubcontractingCostDetail(translateService);
const oDC_Travel = new Domain.ODC_Travel(translateService);
const oDC_Equipment = new Domain.ODC_Equipment(translateService);
const oDC_OtherGoods = new Domain.ODC_OtherGoods(translateService);
const approvalHistory = new Domain.ApprovalHistory(translateService);
const costStatementEffortDetail = new Domain.CostStatementEffortDetail(translateService);
const expenseReportDetail = new Domain.ExpenseReportDetail(translateService);
const expenseReport = new Domain.ExpenseReport(translateService);
const expenseCategory = new Domain.ExpenseCategory(translateService);
const expenseReportStatusTransition = new Domain.ExpenseReportStatusTransition(translateService);
const email = new Domain.Email(translateService);
const emailHelper = new Domain.EmailHelper(translateService);
const errorMessage = new Domain.ErrorMessage(translateService);
const util = new Domain.Util(translateService);
const applicationInfo = new Domain.ApplicationInfo(translateService);
const gateKeeper = new Domain.GateKeeper(translateService);
const supportRequest = new Domain.SupportRequest(translateService);
const meeting = new Domain.Meeting(translateService);
const location = new Domain.Location(translateService);
const meetingAttendee = new Domain.MeetingAttendee(translateService);
const employmentContract = new Domain.EmploymentContract(translateService);
const employee = new Domain.Employee(translateService);
const employmentType = new Domain.EmploymentType(translateService);
const invoicingEntity = new Domain.InvoicingEntity(translateService);
const employeeWorkData = new Domain.EmployeeWorkData(translateService);
const contractWorkDay = new Domain.ContractWorkDay(translateService);
const eCEmployeeCategory = new Domain.ECEmployeeCategory(translateService);
const leavePolicy = new Domain.LeavePolicy(translateService);
const typeOfLeave = new Domain.TypeOfLeave(translateService);
const leaveRequest = new Domain.LeaveRequest(translateService);
const leaveApproval = new Domain.LeaveApproval(translateService);
const leaveBalance = new Domain.LeaveBalance(translateService);
const person = new Domain.Person(translateService);
const memberInvitation = new Domain.MemberInvitation(translateService);
const contact = new Domain.Contact(translateService);
const team = new Domain.Team(translateService);
const personOrgAffiliation = new Domain.PersonOrgAffiliation(translateService);
const officeAttendanceSchedule = new Domain.OfficeAttendanceSchedule(translateService);
const officeAttendance = new Domain.OfficeAttendance(translateService);
const attendanceStatusDTO = new Domain.AttendanceStatusDTO(translateService);
const timesheet = new Domain.Timesheet(translateService);
const timesheetEntry = new Domain.TimesheetEntry(translateService);
const timesheetProjectSummary = new Domain.TimesheetProjectSummary(translateService);
const timesheetVM = new Domain.TimesheetVM(translateService);
const timesheetEntryVM = new Domain.TimesheetEntryVM(translateService);
const employeeVM = new Domain.EmployeeVM(translateService);
const mapper = new Domain.Mapper(translateService);
const serviceProvider = new Domain.ServiceProvider(translateService);
const participantWorkVM = new Domain.ParticipantWorkVM(translateService);
const deliverableVM = new Domain.DeliverableVM(translateService);
const milestoneVM = new Domain.MilestoneVM(translateService);
const taskVM = new Domain.TaskVM(translateService);
const employeeForServiceVM = new Domain.EmployeeForServiceVM(translateService);
const leaveRequestVM = new Domain.LeaveRequestVM(translateService);
const appInfo = new Domain.AppInfo(translateService);
const payrollPaymentDataObject = new Domain.PayrollPaymentDataObject(translateService);
const monthlyEmployeeForecast = new Domain.MonthlyEmployeeForecast(translateService);
const projectForecast = new Domain.ProjectForecast(translateService);
const projectPlan = new Domain.ProjectPlan(translateService);
const assignedResource = new Domain.AssignedResource(translateService);
const planPerProjectCostSummary = new Domain.PlanPerProjectCostSummary(translateService);
const assignedResourceMonthAllocation = new Domain.AssignedResourceMonthAllocation(translateService);
const trip = new Domain.Trip(translateService);
const tripTraveller = new Domain.TripTraveller(translateService);
const tripApproval = new Domain.TripApproval(translateService);
const timesheetReport = new Domain.TimesheetReport(translateService);
const projectPersonnelClaimsReport = new Domain.ProjectPersonnelClaimsReport(translateService);
const projectPersonnelClaimsReportMonthDetail = new Domain.ProjectPersonnelClaimsReportMonthDetail(translateService);
const projectPersonnelClaimsEmployeeDetail = new Domain.ProjectPersonnelClaimsEmployeeDetail(translateService);
const projectPersonnelClaimsEmployeeSummary = new Domain.ProjectPersonnelClaimsEmployeeSummary(translateService);
const allProjectsReport = new Domain.AllProjectsReport(translateService);
const monthlyCostApportionment = new Domain.MonthlyCostApportionment(translateService);
const projectOverview = new Domain.ProjectOverview(translateService);
const projectOverviewDetail = new Domain.ProjectOverviewDetail(translateService);
const projectsProjections = new Domain.ProjectsProjections(translateService);
const timeEntry = new Domain.TimeEntry(translateService);
const eUProgramme = new Domain.EUProgramme(translateService);
const unitCostRate = new Domain.UnitCostRate(translateService);
const correctionCoefficient = new Domain.CorrectionCoefficient(translateService);
const notificationManager = new Domain.NotificationManager(translateService);
const issue = new Domain.Issue(translateService);
const treeNode = new Domain.TreeNode(translateService);
const projectClaimsVsActualCosts = new Domain.ProjectClaimsVsActualCosts(translateService);
const employeeClaimsVsActualCosts = new Domain.EmployeeClaimsVsActualCosts(translateService);
const calendar = new Domain.Calendar(translateService);
const calendarEvent = new Domain.CalendarEvent(translateService);
const loomSynchonizer = new Domain.LoomSynchonizer(translateService);
const timelineResource = new Domain.TimelineResource(translateService);
const timelineControlHelper = new Domain.TimelineControlHelper(translateService);
const timelineEvent = new Domain.TimelineEvent(translateService);
const timelineControlData = new Domain.TimelineControlData(translateService);
const timelineEventExtendedProps = new Domain.TimelineEventExtendedProps(translateService);
const timelineEventPart = new Domain.TimelineEventPart(translateService);
const timelineProjectMonth = new Domain.TimelineProjectMonth(translateService);
const dateHelper = new Domain.DateHelper(translateService);
const customValidationDTO = new Domain.CustomValidationDTO(translateService);
const customValidationItemDTO = new Domain.CustomValidationItemDTO(translateService);
const benefitType = new Domain.BenefitType(translateService);
const employeeBenefit = new Domain.EmployeeBenefit(translateService);
const salaryPayment = new Domain.SalaryPayment(translateService);
const salaryPaymentSeedLineDTO = new Domain.SalaryPaymentSeedLineDTO(translateService);
const salaryPaymentSeedDTO = new Domain.SalaryPaymentSeedDTO(translateService);
const invoice = new Domain.Invoice(translateService);
const invoiceTax = new Domain.InvoiceTax(translateService);
const invoiceItem = new Domain.InvoiceItem(translateService);
const timesheetYearlyEmployeeReport = new Domain.TimesheetYearlyEmployeeReport(translateService);
const serviceProviderDev2 = new Domain.ServiceProviderDev2(translateService);
const serviceProviderDev1 = new Domain.ServiceProviderDev1(translateService);
const applicationUserAction = new Domain.ApplicationUserAction(translateService);
const applicationUserExternalProfile = new Domain.ApplicationUserExternalProfile(translateService);
const applicationSetting = new Domain.ApplicationSetting(translateService);
const applicationUser = new Domain.ApplicationUser(translateService);
const applicationRole = new Domain.ApplicationRole(translateService);
const applicationOperation = new Domain.ApplicationOperation(translateService);
const applicationPermission = new Domain.ApplicationPermission(translateService);
const applicationClient = new Domain.ApplicationClient(translateService);
const applicationUserLogin = new Domain.ApplicationUserLogin(translateService);
const applicationUserClaim = new Domain.ApplicationUserClaim(translateService);
const profileSetting = new Domain.ProfileSetting(translateService);
const profile = new Domain.Profile(translateService);
const applicationLanguage = new Domain.ApplicationLanguage(translateService);
const applicationTimezoneInfo = new Domain.ApplicationTimezoneInfo(translateService);
const dateTimeFormat = new Domain.DateTimeFormat(translateService);
const applicationTheme = new Domain.ApplicationTheme(translateService);
const fileData = new Domain.FileData(translateService);
const auditEntityConfiguration = new Domain.AuditEntityConfiguration(translateService);
const auditPropertyConfiguration = new Domain.AuditPropertyConfiguration(translateService);
const auditLogEntry = new Domain.AuditLogEntry(translateService);
const auditLogEntryType = new Domain.AuditLogEntryType(translateService);
const auditLogPropertyActionType = new Domain.AuditLogPropertyActionType(translateService);
const workflowExecutionResult = new Domain.WorkflowExecutionResult(translateService);
const workflowContextBase = new Domain.WorkflowContextBase(translateService);
const workflowSchedule = new Domain.WorkflowSchedule(translateService);
const synchWithClickUpContext = new Domain.SynchWithClickUpContext(translateService);
 }

}
